import "assets/theme.css";

export const narrowWidth = 700;
export const wideWidth = 1200;
